import { Font, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import opnSansBold from '../../../../assets/fonts/Open_Sans/static/OpenSans-Bold.ttf';
import opnSansBoldItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-BoldItalic.ttf';
import opnSansExtraBold from '../../../../assets/fonts/Open_Sans/static/OpenSans-ExtraBold.ttf';
import opnSansExtraBoldItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-ExtraBoldItalic.ttf';
//italic
import opnSansRItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-Italic.ttf';
import opnSansLight from '../../../../assets/fonts/Open_Sans/static/OpenSans-Light.ttf';
import opnSansLightItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-LightItalic.ttf';
import opnSansMedium from '../../../../assets/fonts/Open_Sans/static/OpenSans-Medium.ttf';
import opnSansMediumItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-MediumItalic.ttf';
//Regular
import opnSansRegular from '../../../../assets/fonts/Open_Sans/static/OpenSans-Regular.ttf';
import opnSansSemiBold from '../../../../assets/fonts/Open_Sans/static/OpenSans-SemiBold.ttf';
import opnSansSemiBoldItalic from '../../../../assets/fonts/Open_Sans/static/OpenSans-SemiBoldItalic.ttf';
import PDFCheckBoxImg from './PDFCheckBoxImg';

Font.register({
  family: 'Open Sans',
  format: 'truetype',
  fonts: [
    {
      src: opnSansRegular,
    },
    {
      src: opnSansLight,
      fontWeight: 200,
    },
    {
      src: opnSansRegular,
      fontWeight: 400,
    },
    {
      src: opnSansMedium,
      fontWeight: 500,
    },
    {
      src: opnSansSemiBold,
      fontWeight: 600,
    },
    {
      src: opnSansBold,
      fontWeight: 700,
    },
    {
      src: opnSansExtraBold,
      fontWeight: 800,
    },
  ],
});

Font.register({
  family: 'Open Sans Italic',
  format: 'truetype',
  fonts: [
    {
      src: opnSansRItalic,
    },
    {
      src: opnSansLightItalic,
      fontWeight: 200,
    },
    {
      src: opnSansRItalic,
      fontWeight: 400,
    },
    {
      src: opnSansMediumItalic,
      fontWeight: 500,
    },
    {
      src: opnSansSemiBoldItalic,
      fontWeight: 600,
    },
    {
      src: opnSansBoldItalic,
      fontWeight: 700,
    },
    {
      src: opnSansExtraBoldItalic,
      fontWeight: 800,
    },
  ],
});

Font.registerHyphenationCallback((word) => [word]);

export const PDFRow = ({ children, style = {}, justify = 'start', align = 'top', direction = 'row', ...rest }) => {
  const styles = StyleSheet.create({
    row: {
      display: 'flex',
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      ...style,
    },
  });
  return (
    <View style={styles.row} {...rest}>
      {children}
    </View>
  );
};

export const PDFText = ({ children, style = {}, preventOverlap = false, ...rest }) => {
  const styles = StyleSheet.create({
    text: {
      fontFamily: 'Open Sans',
      fontSize: 10,
      fontWeight: '400',
      wordWrap: 'break-word',
      ...style,
    },
  });

  if (preventOverlap) {
    //NOTE - To fix text overlap if the string does't not have the space to break into next line.
    //NOTE - This issue is still persist in later version(4.0.0) of @react-pdf/renderer
    //TODO - Will cleaned up this below approach once this text overlap issue is fixed in upcoming versions
    //STUB - Kindly use this approach on demand based only
    return (
      <View style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
        {String(children)
          .split('')
          .map((val) => (
            <Text key={val} style={styles.text} {...rest}>
              {val}
            </Text>
          ))}
      </View>
    );
  }
  return (
    <Text style={styles.text} {...rest}>
      {children}
    </Text>
  );
};

export const PDFDarkHeader = ({ children, style = {}, textStyles = {}, isFirst }) => {
  const styles = StyleSheet.create({
    header: {
      width: '100%',
      backgroundColor: 'black',
      paddingBottom: isFirst ? 1 : 0,
      paddingVertical: isFirst ? 0 : 1,
      ...style,
    },
  });
  return (
    <Text style={styles.header}>
      <PDFText style={{ ...{ color: 'white', textAlign: 'center' }, ...textStyles }}>{children}</PDFText>
    </Text>
  );
};

export const PDFTable = ({ children, style = {} }) => {
  const styles = StyleSheet.create({
    text: {
      width: '100%',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      ...style,
    },
  });
  return <View style={styles.text}>{children}</View>;
};

export const PDFTableRow = ({ children, style = {}, ...rest }) => {
  const styles = StyleSheet.create({
    text: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'nowrap',
      ...style,
      // backgroundColor: "blue",
      // alignItems: "stretch",
    },
  });
  return (
    <View style={styles.text} {...rest}>
      {children}
    </View>
  );
};

export const PDFTableCell = ({
  children,
  style = {},
  width = 'auto',
  borderTop = true,
  borderRight = true,
  borderBottom = true,
  borderLeft = true,
  padding = 3,
  justify = 'center',
  ...rest
}) => {
  const styles = StyleSheet.create({
    view: {
      marginTop: -1,
      marginLeft: -1,
      width,
      paddingHorizontal: padding,
      paddingVertical: 0,
      borderTop: getTableCellBorder(borderTop),
      borderRight: getTableCellBorder(borderRight),
      borderBottom: getTableCellBorder(borderBottom),
      borderLeft: getTableCellBorder(borderLeft),
      ...style,
      // backgroundColor: "yellow",
      display: 'flex',
      flexDirection: 'column',
      justifyContent: justify,
    },
  });
  return (
    <View style={styles.view} {...rest}>
      {children}
    </View>
  );
};

export const PDFDivider = ({ style = {} }) => {
  const styles = StyleSheet.create({
    view: {
      width: '100%',
      borderBottom: '1px solid black',
      ...style,
    },
  });
  return <View style={styles.view} />;
};

export const PdfGetTextUnderline = ({ value, fontWeight = '400' }) => {
  return (
    <PDFText
      style={{
        textDecoration: value ? 'underline' : 'none',
        fontWeight,
      }}
    >
      {!value ? '__________________' : value}
    </PDFText>
  );
};

export const PDFCheckBox = ({
  value = false,
  label = 'label',
  size = 10,
  fontSize = 8,
  fontWeight = '700',
  isReverse = false,
  colon = true,
}) => {
  const styles = StyleSheet.create({
    text: {
      fontSize,
      fontWeight,
    },
  });
  return (
    <PDFRow
      direction={isReverse ? 'row-reverse' : 'row'}
      style={{ flexWrap: 'nowrap', alignItems: 'center' }}
      justify={`flex-${isReverse ? 'end' : 'start'}`}
    >
      <PDFText style={styles.text}>{label}</PDFText>
      {colon && <PDFText style={{ ...styles.text, marginLeft: 1, marginRight: 3 }}>:</PDFText>}

      {colon ? '' : <View style={{ width: 5 }} />}

      <View>
        <PDFCheckBoxImg size={size} isChecked={value} />
      </View>
    </PDFRow>
  );
};

export const PDFPage = ({ children, paddingHorizontal = 10, paddingVertical = 20, style = {} }) => {
  const styles = StyleSheet.create({
    page: {
      ontFamily: 'Open Sans',
      flexDirection: 'column',
      display: 'flex',
      height: 'auto',
      paddingHorizontal,
      paddingVertical,
    },
  });

  return (
    <Page size="A4" style={{ ...styles.page, ...style }} orientation="portrait">
      {children}
    </Page>
  );
};

export const pdfStyles = StyleSheet.create({
  borderTop: {
    borderTop: '1px solid black',
  },
  borderRight: {
    borderRight: '1px solid black',
  },
  borderBottom: {
    borderBottom: '1px solid black',
  },
  borderLeft: {
    borderLeft: '1px solid black',
  },
  border: { border: '1px solid black' },
  header: { paddingHorizontal: 10, paddingVertical: 5 },
  title: { fontSize: 16, fontWeight: '700' },
  headerRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  section: {
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  imageSection: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
  },
  image: {
    width: '60%',
  },
  tableHeader: {
    fontWeight: '700',
    fontSize: 8,
    textAlign: 'center',
  },
  tableCol: {
    fontSize: 8,
  },
});

export const getTableCellBorder = (val) => (val === true ? '1px solid black' : 'none');
